import { environment } from '../../../../environments/environment';

export class AvailabilityService {
  static $inject = ['RestResource', 'CONFIGURATIONS'];

  constructor(private RestResource, private CONFIGURATIONS) {}

  apiUrl = environment.apiEndpoint + 'availabilities';

  dateDisplay = this.CONFIGURATIONS.dateDisplay;

  getAvailabilitySchedule(filter) {
    const url = this.apiUrl + '/get_availability_schedule';

    return this.RestResource.request(
      'get',
      url,
      filter,
      function (response) {
        return response.data;
      },
      function (err) {
        return err;
      }
    );
  }

  getProvidersCostAndPrices(filter) {
    const url = this.apiUrl + '/get_providers_cost_and_prices';

    return this.RestResource.request(
      'get',
      url,
      filter,
      function (response) {
        return response.data;
      },
      function (err) {
        return err;
      }
    );
  }
}
